import { IconCamera } from "../CustomIcons/IconCamera";

export const GalleryCounter = ({ activeIndex, imagesLength }: { activeIndex: number; imagesLength: number }) => (
    <div className="gallery-counter rounded-1 d-flex align-items-center">
        <IconCamera width={13} height={13} className="text-white me-2" />
        <span className="text-white">
            {activeIndex + 1} / {imagesLength}
        </span>
    </div>
);